<template>
    <div class="formgrid grid">
        <div class="field col-12">
            <Dropdown inputId="brand" v-if="brands.length > 0" v-model="selectedBrandAlias" :options="brands" optionLabel="displayName"
                optionValue="alias" placeholder="Vælg mærke" aria-label="Vælg mærke"></Dropdown>
        </div>
        <div class="field col-12">
            <Dropdown inputId="shop" v-if="shops.length > 0" v-model="selectedShopId" :options="shops" optionLabel="name" optionValue="id"
                placeholder="Vælg forretning" aria-label="Vælg forretning"></Dropdown>
        </div>
    </div>
    <Button class="p-button-secondary" v-if="selectedShop != null" @click="visible = true">Åben bookingvindue</Button>

    <Dialog v-if="selectedShop != null" class="workshop-booking__dialog" v-model:visible="visible" :dismissableMask="true"
        :draggable="false" modal :header="`Værkstedsbooking hos ${selectedShop.name}`"
        :style="{ width: '100%', maxWidth: '1120px', height: '90vh' }">
        <iframe :src="`https://${selectedShop.website}/Vaerksted/Bestil-tid-paa-vaerkstedet/?simple=true`"
            style="width:100%;height:100%"></iframe>
    </Dialog>
    <div v-show="loading" class="field col-12">
        <p>Indlæser <i class="pi pi-spin pi-spinner"></i></p>
    </div>
</template>
<script>

import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
export default {
    name: "workshopBooking",
    components: {
        Dialog,
        Button,
        Dropdown
    },
    props: ['branchesNodeId', 'predefinedShops'],
    data() {
        return {
            dictionary: [],
            brands: [],
            selectedBrandAlias: null,
            shops: [],
            selectedShopId: null,
            selectedShop: null,
            visible: false,
            allowedTypes: [3]
        };
    },
    created() {
        const vm = this;
        vm.loading = true;
        fetch('/umbraco/api/shopApi/GetBrands')
            .then(response => response.json())
            .then(data => {
                vm.brands = data;
                vm.loading = false;

            })
            .catch(error => {
                console.log(error);
                vm.loading = false;

            })
    },
    watch: {
        selectedBrandAlias: {
            handler(newVal, oldVal) {
                this.handleBrandChange(newVal);
            }
        },
        selectedShopId: {
            handler(newVal, oldVal) {
                this.handleShopChange(newVal);
            }
        }
    },
    methods: {
        handleBrandChange(brand) {
            const vm = this;
            vm.loading = true;

            vm.shops = [];
            vm.selectedShopId = null,
                vm.selectedShop = null;
            fetch('/umbraco/api/shopApi/GetShopsByBrand?brand=' + brand)
                .then(response => response.json())
                .then(data => {
                    vm.shops = data.filter(x => x.departments.some(x => vm.allowedTypes.includes(x.typeId)));
                    vm.loading = false;

                })
                .catch(error => {
                    console.log(error);
                    vm.loading = false;

                })
        },
        handleShopChange(shopId) {
            if (shopId) {
                const shop = this.shops.find(x => x.id == shopId);
                if (shop) {
                    this.selectedShop = shop;
                    this.visible = true;
                } else {
                    this.selectedShop = null;
                    this.visible = false;
                }
            }
        }
    }
};
</script>
